/**
 * This class handles background activity on modal.
 */
export class BannerListenerService {
    static get bannerHeight(): Number {
        const bannerParent = document.getElementById('uc-banner-modal');
        if (bannerParent) {
            const bannerDivs = bannerParent.getElementsByClassName('uc-banner-content');
            if (bannerDivs.length) {
                const bannerDiv = bannerDivs[0];
                return bannerDiv.clientHeight;
            }
        }
        return 0;
    }

    /**
     * Returns the height of the banner minus the height of the banner message
     * @returns Height in pixels or 0 if elements are missing/hidden
     */
    static get bannerDiff(): Number {
        const bannerParent = document.getElementById('uc-banner-modal');
        if (bannerParent) {
            const bannerDivs = bannerParent.getElementsByClassName('uc-banner-content');
            if (bannerDivs.length) {
                const bannerDiv = bannerDivs[0];
                const optinDescDivs = bannerDiv.getElementsByClassName('uc-optin-description');
                if (optinDescDivs.length) {
                    const optinDescDiv = optinDescDivs[0];
                    return bannerDiv.clientHeight - optinDescDiv.clientHeight;
                }
            }
        }
        return 0;
    }
}
